import React, { useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const PromptModal = ({ isOpen, onClose, prompt }) => {
  const isLoading = prompt === 'Loading prompt...';

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="w-full max-w-3xl max-h-[1080px] overflow-hidden gap-0"
        style={{ 
          height: isLoading ? '200px' : 'calc(100vh - 160px)',
          minHeight: isLoading ? '200px' : undefined,
          animationDuration: '0ms !important', 
          transitionDuration: '0ms !important',
          animation: 'none !important',
          transition: 'none !important'
        }}
      >
        <style>
        {`.custom-default-scrollbar::-webkit-scrollbar {
                -webkit-appearance: none;
                height: 2px;
                max-height: 28px;
                width: 2px;
                padding-right: 10px;
                padding-left: 10px;
            }
            .custom-default-scrollbar::-webkit-scrollbar-track {
              background-color: rgba(0, 0, 0, .05);
            }
            .custom-default-scrollbar::-webkit-scrollbar-thumb {
                border-radius: 2px;
                background-color: rgba(0, 0, 0, .2);
                padding-right: 10px;
                padding-left: 10px;
        }`}
        </style>
        <DialogHeader className="!space-y-0 h-[32px] p-0 mb-6">
          <DialogTitle className="text-xl font-semibold mobile:text-lg">
            Prompt Used
          </DialogTitle>
        </DialogHeader>
        <div className="overflow-auto h-[calc(82vh - 100px)] mobile:p-3">
          <pre className="custom-default-scrollbar whitespace-pre-wrap font-mono text-sm text-[#6B7280] bg-[#F1F5F9] p-4 rounded-md mobile:p-2 mobile:text-xs">
            {prompt || 'No prompt available'}
          </pre>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PromptModal;